import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const post_Comment = (data: any) => {
    return axios({
        url: `${ticketBaseURL}comment`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Comment = (data: any) => {
    return axios({
        url: `${ticketBaseURL}comment`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Comment = (primaryKey: string) => {
    return axios({
        url: `${ticketBaseURL}comment`,
        method: "DELETE",
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getComments = (attributeName: string, attributeId: string) => {
    return axios({
        url: `${ticketBaseURL}comment/${attributeName},${attributeId}`,
        method: "GET"
    }).then(response => response.data);
}

export const getThreadedComments  = (attributeName: string, attributeId: number) => {
     return axios({
        url: `${ticketBaseURL}comment/GetThreadedComments/${attributeName},${attributeId}`,
        method: "GET"
    }).then(response => response.data);
}